import React, { useState, useEffect } from "react";
import "./Masala.css";
import Taxrirlovchi from "../Taxrirlovchi";
import Sarlavha from "./Sarlavha";
import Savol from "./Savol";
import { toast } from "react-toastify";
import { FaChevronLeft, FaChevronRight, FaTimes, FaPlayCircle, FaLock } from "react-icons/fa";
import DarsVideoPlayer from "../Kurs/DarsVideoPlayer";
import CONFIG from "../config";

function Masala({ js, setJs, baza, Natija, rasm, toggleUserPanel, userPanelOpen, darkMode, refreshUserData, userData }) {
  const [loading, setLoading] = useState(true);
  const [joriyMasala, setJoriyMasala] = useState(null);
  const [metadata, setMetadata] = useState({ current_index: 0, total_count: 0 });
  const [baho, setBaho] = useState(null);
  const [error, setError] = useState(null);
  const [videoOpen, setVideoOpen] = useState(false);

  // New State for Video Help
  const [helpVideos, setHelpVideos] = useState([]);
  const [helpModalOpen, setHelpModalOpen] = useState(false);
  const [secureVideoUrl, setSecureVideoUrl] = useState(null);
  const [activeHelpId, setActiveHelpId] = useState(null); // Track by ID instead of URL
  const [purchaseConfirm, setPurchaseConfirm] = useState(null); // { id, narx, nomi }
  const [isSolved, setIsSolved] = useState(false);
  const [solvedTime, setSolvedTime] = useState(0);
  const [videoLoading, setVideoLoading] = useState(false);

  const [startTime, setStartTime] = useState(Date.now());
  const [elapsedTime, setElapsedTime] = useState(0);
  const timeCache = React.useRef({}); // Save elapsed time for unfinished problems

  // Timer Logic
  useEffect(() => {
    let interval = null;
    if (joriyMasala && !baho) { // Run only if problem exists and not yet solved (baho set implies end)
      interval = setInterval(() => {
        setElapsedTime(Math.floor((Date.now() - startTime) / 1000));
      }, 1000);
    } else {
      clearInterval(interval);
    }
    return () => clearInterval(interval);
  }, [joriyMasala, isSolved, startTime]); // Removed baho from dep, using isSolved

  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
  };

  // Navigation Logic
  const handleProblemSelect = (index) => {
    fetchProblem(index);
  };

  const handleSectionSelect = (bolimId) => {
    // Reset index to -1 (default first) when switching section
    fetchProblem(-1, bolimId);
  };

  const fetchProblem = (index = -1, bolimId = null) => {
    // Save timer state for current unsolved problem before switching
    if (joriyMasala && !isSolved) {
      timeCache.current[joriyMasala.id] = elapsedTime;
    }

    setLoading(true);
    const user = JSON.parse(localStorage.getItem("loyiha_user") || "{}");
    const userId = user.id || 0;

    const token = localStorage.getItem("loyiha_token");
    let url = `${CONFIG.API_BASE_URL}/get_masalalar.php?user_id=${userId}&token=${token}`;

    // If explicit bolimId passed, use it. Otherwise use metadata's current bolim_id (if exists) or default.
    // Ideally, we persist the chosen section in URL or state, but here we rely on API state/param.
    const targetBolim = bolimId || (metadata && metadata.bolim_id ? metadata.bolim_id : 0);

    if (targetBolim > 0) url += `&bolim_id=${targetBolim}`;
    if (index >= 0) url += `&masala_index=${index}`;

    fetch(url, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    })
      .then(res => res.json())
      .then(data => {
        if (data.status === 'success' && data.data.problem) {
          const prob = data.data.problem;
          setJoriyMasala(prob);
          setMetadata(data.data.metadata);

          if (prob.is_solved) {
            setIsSolved(true);
            setSolvedTime(prob.user_time || 0);
            setJs(prob.user_solution || "");
            setBaho(5); // Show full stars/marks if solved, logic might vary
          } else {
            setIsSolved(false);
            setSolvedTime(0);
            setBaho(null);
            setJs("");

            // Restore Timer if we have cached time for this problem
            const saved = timeCache.current[prob.id];
            if (saved) {
              setStartTime(Date.now() - (saved * 1000));
              setElapsedTime(saved);
            } else {
              setStartTime(Date.now());
              setElapsedTime(0);
            }
          }
        }
        setLoading(false);
      })
      .catch(err => {
        console.error("Masalalar fetch error:", err);
        setLoading(false);
      });
  };

  const fetchHelpVideos = (masalaId) => {
    const token = localStorage.getItem("loyiha_token");
    fetch(`${CONFIG.API_BASE_URL}/get_help.php?masala_id=${masalaId}&token=${token}`, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    })
      .then(res => res.json())
      .then(data => {
        console.log(`Help videos for masala ${masalaId}:`, data);
        if (data.status === 'success') {
          setHelpVideos(data.data);

          // Always set the first video as active if none selected
          if (data.data.length > 0 && !activeHelpId) {
            setActiveHelpId(data.data[0].id);
          }

          // Auto-open logic for New Users (0 solved) - only ONCE
          const user = JSON.parse(localStorage.getItem("loyiha_user") || "{}");
          const introShown = localStorage.getItem("intro_video_shown");

          if (user.yechilgan_lar_soni === 0 && data.data.length > 0 && !introShown) {
            console.log("Auto-open triggered for new user");
            setTimeout(() => {
              setHelpModalOpen(true);
              localStorage.setItem("intro_video_shown", "true");
            }, 5000);
          }
        }
      })
      .catch(console.error);
  };



  useEffect(() => {
    fetchProblem();
  }, []);

  useEffect(() => {
    if (joriyMasala && joriyMasala.id) {
      setHelpVideos([]); // Reset videos
      setActiveHelpId(null); // Reset active video ID
      setBaho(null); // Reset score
      setError(null); // Reset error
      fetchHelpVideos(joriyMasala.id);
    }
  }, [joriyMasala]);

  // Simplified Video URL Mapping (No extra fetch, avoiding refresh bug)
  // Fetch Video as Blob via POST
  useEffect(() => {
    const activeVideo = helpVideos.find(v => v.id === (activeHelpId || (helpVideos.length > 0 ? helpVideos[0].id : null)));

    // Cleanup previous object URL
    return () => {
      if (secureVideoUrl && secureVideoUrl.startsWith('blob:')) {
        URL.revokeObjectURL(secureVideoUrl);
      }
    };
  }, [secureVideoUrl]); // Cleanup effect

  useEffect(() => {
    const activeVideo = helpVideos.find(v => v.id === (activeHelpId || (helpVideos.length > 0 ? helpVideos[0].id : null)));

    if (activeVideo && activeVideo.is_unlocked) {
      // Fetch as Blob via POST
      // REFACTOR: Now using direct fields from API response
      let vId = activeVideo.id;
      let vOtp = activeVideo.otp;
      let vToken = activeVideo.token;

      // Fallback: If for some reason API didn't return them but they are in URL (legacy support)
      if (!vOtp && activeVideo.url && activeVideo.url.includes('otp=')) {
        console.log("Using Legacy URL parsing for OTP");
        try {
          const urlObj = new URL(activeVideo.url, CONFIG.API_BASE_URL);
          vOtp = urlObj.searchParams.get('otp');
          if (!vToken) vToken = urlObj.searchParams.get('token');
        } catch (e) {
          const otpMatch = activeVideo.url.match(/[?&]otp=([^&]+)/);
          if (otpMatch) vOtp = otpMatch[1];
        }
      }

      console.log("Preparing Secure POST:", { vId, hasOtp: !!vOtp });

      if (vId && vOtp) {
        setVideoLoading(true);
        fetch(`${CONFIG.API_BASE_URL}/secure_video.php`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: parseInt(vId), otp: vOtp, token: vToken })
        })
          .then(async res => {
            if (!res.ok) {
              const errText = await res.text();
              console.error("Secure Video Fetch Error:", res.status, errText);
              throw new Error(`Server returned ${res.status}: ${errText}`);
            }
            return res.blob();
          })
          .then(blob => {
            const objUrl = URL.createObjectURL(blob);
            setSecureVideoUrl(objUrl);
            setVideoLoading(false);
          })
          .catch(err => {
            console.error("Video Blob fetch failed", err);
            setVideoLoading(false);
            // Fallback to original URL if fetch fails? (Maybe not secure but works)
            // setSecureVideoUrl(activeVideo.url); 
          });
      } else if (activeVideo.url) {
        setVideoLoading(false);
        // Direct link (not secure_video.php) or other format
        setSecureVideoUrl(activeVideo.url);
      } else {
        setVideoLoading(false);
        setSecureVideoUrl('');
      }

    } else {
      setVideoLoading(false);
      setSecureVideoUrl('');
    }
  }, [activeHelpId, helpVideos]);

  const tekshirish = async (kod) => {
    if (isSolved) {
      toast.info("Bu masala allaqachon yechilgan.");
      return;
    }
    if (!kod || kod.trim() === "") {
      toast.warning("Kod oynasi bo'sh!");
      return;
    }
    // toast.info("Tekshirilmoqda...", { autoClose: 1000 }); // Debug toast
    const masala = joriyMasala;
    let togri = 0;
    setError(null);

    try {
      masala.testCases.forEach((test) => {
        // Prepare inputs
        const argNames = Object.keys(test.inputs);
        const argValues = Object.values(test.inputs);

        let result = null;
        const mockChop = (val) => { result = val; };

        // Wrap user code in a block to allow shadowing defaults with let/const
        const userFunc = new Function(...argNames, 'chop', `{\n${kod}\n}`);
        userFunc(...argValues, mockChop);

        // Check equality with float tolerance
        let isMatch = (result == test.output);
        if (!isMatch) {
          const numRes = parseFloat(result);
          const numOut = parseFloat(test.output);
          if (!isNaN(numRes) && !isNaN(numOut)) {
            // Allow small difference (epsilon) for float errors
            if (Math.abs(numRes - numOut) < 0.000001) isMatch = true;
          }
        }

        if (isMatch) {
          togri++;
        }
      });

      // Calculate score out of 5
      const ball = Math.round((togri / masala.testCases.length) * 5);
      setBaho(ball);

      const sarflangan_vaqt = Math.round((Date.now() - startTime) / 1000);

      if (ball >= 4) {
        // Save progress to server
        const user = JSON.parse(localStorage.getItem("loyiha_user") || "{}");
        if (user.id) {
          // DEBUG: Alert user ID and token
          // alert(`DEBUG: Submitting. UserID: ${user.id}, MasalaID: ${joriyMasala.id}`);

          try {
            const token = localStorage.getItem("loyiha_token");
            const resp = await fetch(`${CONFIG.API_BASE_URL}/submit_yechim.php?token=${token}`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
              },
              body: JSON.stringify({
                user_id: user.id,
                masala_id: joriyMasala.id,
                yechim_kodi: kod,
                holati: 'accepted',
                baho: ball,
                sarflangan_vaqt: sarflangan_vaqt
              })
            });

            const resData = await resp.json();
            // console.log("Server response:", resData);

            if (resData.status === 'success') {
              if (refreshUserData) refreshUserData();

              if (resData.olingan_ball > 0) {
                toast.success(`Sizning bahoyingiz: ${ball} ball. Tabriklaymiz!`);
              } else {
                toast.warning(`Masala yechildi, lekin video yordam olganingiz uchun tanga berilmadi.`);
              }
            } else {
              toast.error(resData.message);
            }

          } catch (fetchErr) {
            console.error(fetchErr);
            toast.error("Tarmoq xatoligi!");
          }
        }
        else {
          console.warn("Foydalanuvchi tizimga kirmagan, natija saqlanmadi.");
          toast.error("Natijani saqlash uchun tizimga kiring!");
        }

        if (metadata.current_index < metadata.total_count) {
          setTimeout(() => {
            toast.info("Keyingi bosqichga o'tdingiz.");
            fetchProblem(); // Fetch the NEXT problem
            setJs("");
            setBaho(null);
            setError(null);
          }, 1500);
        } else {
          toast.success("Ushbu bo'limdagi barcha masalalar yechildi! Ofarin!");
        }
      } else {
        toast.error("Javob noto'g'ri! Qayta urinib ko'ring.");
        let xabar = "Ba'zi testlardan o'tmadi:\n";

        // Save FAILED attempt to server
        // Save FAILED attempt to server
        const user = JSON.parse(localStorage.getItem("loyiha_user") || "{}");
        if (user.id) {
          try {
            const token = localStorage.getItem("loyiha_token");
            const resp = await fetch(`${CONFIG.API_BASE_URL}/submit_yechim.php?token=${token}`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
              },
              body: JSON.stringify({
                user_id: user.id,
                masala_id: joriyMasala.id,
                yechim_kodi: kod,
                holati: 'wrong_answer',
                baho: ball,
                sarflangan_vaqt: sarflangan_vaqt
              })
            });
            const respText = await resp.text();
            // alert("DEBUG SERVER (Xato javob): " + respText);
          } catch (e) {
            // alert("Network error on fail submit: " + e.message);
          }
        }
        // Find first failed case for feedback
        masala.testCases.forEach((test) => {
          const argNames = Object.keys(test.inputs);
          const argValues = Object.values(test.inputs);
          let result = null;
          const mockChop = (val) => { result = val; };
          try {
            const userFunc = new Function(...argNames, 'chop', `{\n${kod}\n}`);
            userFunc(...argValues, mockChop);
            let isMatch = (result == test.output);
            if (!isMatch) {
              const numRes = parseFloat(result);
              const numOut = parseFloat(test.output);
              if (!isNaN(numRes) && !isNaN(numOut)) {
                if (Math.abs(numRes - numOut) < 0.000001) isMatch = true;
              }
            }

            if (!isMatch) {
              xabar += `Input: ${JSON.stringify(test.inputs)} -> Chiqdi: ${result}, Kutilgan: ${test.output}\n`;
            }
          } catch (e) { }
        });
        xabar += "\nQoida: O'zgaruvchilarni (a, b) qayta e'lon qilmang. Ular tizim tomonidan berilgan.";
        setError(xabar);
      }

      // Also run visualization
      // Natija("", "", kod);

    } catch (e) {
      setError("Dasturda xatolik mavjud:\n" + e.message);
    }
  };

  const buyHelp = async (yordamId, narx) => {
    // Custom prompt logic
    setPurchaseConfirm({ id: yordamId, narx: narx });
  };

  const processPurchase = async () => {
    if (!purchaseConfirm) return;
    const { id: yordamId, narx } = purchaseConfirm;
    setPurchaseConfirm(null);

    try {
      const token = localStorage.getItem("loyiha_token");
      const resp = await fetch(`${CONFIG.API_BASE_URL}/buy_help.php?token=${token}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({ yordam_id: yordamId })
      });
      const res = await resp.json();

      if (res.status === 'success' || res.message === 'Allaqachon sotib olingan') {
        toast.success(res.message === 'Allaqachon sotib olingan' ? "Ushbu video allaqachon ochilgan!" : "Muvaffaqiyatli sotib olingdi!");
        // Trigger Red Shadow Animation
        window.dispatchEvent(new Event('spend_coins'));

        if (refreshUserData) refreshUserData(); // Update balance UI

        // Re-fetch videos and find the newly unlocked one
        if (joriyMasala) {
          fetch(`${CONFIG.API_BASE_URL}/get_help.php?masala_id=${joriyMasala.id}&token=${token}`, {
            headers: { 'Authorization': `Bearer ${token}` }
          })
            .then(r => r.json())
            .then(data => {
              if (data.status === 'success') {
                const activeVideo = data.data.find(v => v.id === (activeHelpId || data.data[0].id));
                if (activeVideo && activeVideo.is_unlocked) {
                  // Just rely on state update to trigger useEffect which handles POST fetch
                  // Log for debug
                  console.log("Unlocked video, auto-fetching via effect...");
                }
                setHelpVideos(data.data);
                // Ensure the one we just bought is active
                setActiveHelpId(yordamId);
              } else {
                console.error("Token error:", data.message);
                toast.error("Video yuklashda xatolik (Token)");
              }
            });
        }
      } else {
        toast.error(res.message || "Sizda yetarli tanga mavjud emas!");
      }
    } catch (e) {
      toast.error("Xatolik yuz berdi");
    }
  };

  return (
    <div className="masala-quti">
      <Sarlavha
        chap={metadata.bolim_nomi || "Mantiqiy masalalar"}
        ong={joriyMasala ? `Masala ${metadata.current_index} / ${metadata.total_count}` : ""}
        sectionsList={metadata.sections_list || []}
        onSectionChange={handleSectionSelect}
        activeSectionId={metadata.bolim_id}
      />
      {loading ? (
        <div style={{ textAlign: "center", padding: "20px" }}> Yuklanmoqda... </div>
      ) : joriyMasala ? (
        <>
          <Savol
            matn={joriyMasala.matn || joriyMasala.text}
            currentNumber={metadata.current_index}
            total={metadata.total_count}
            solvedData={metadata.solved_data || {}} // Pass solved data
            onSelect={handleProblemSelect}
            maxUnlockedIndex={metadata.max_unlocked_index || 0}
          />
          <Sarlavha
            chap={"Kod yozish oynasi"}
            ong={baho !== null ? `Baho: ${baho}` : (joriyMasala ? `Qiymati: ${joriyMasala.ball || 0} tanga` : "")}
          />
          <div className="masala-ijrochi-quti">
            <div className="masala-taxrirlovchi">
              <Taxrirlovchi
                til="javascript"
                nomi="JavaScript"
                qiymat={js}
                kodYozish={setJs}
                Natija={(h, c, j) => tekshirish(j)}
                rasm={rasm}
                video={true} // Always show, user will upload videos eventually
                onVideoClick={() => {
                  console.log("Video Yordam Clicked - Setting Modal Open");
                  setHelpModalOpen(true);
                }}
                darkMode={darkMode}
                headerContent={
                  <div style={{
                    flex: 1,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center'
                  }}>
                    <div style={{
                      fontFamily: 'monospace',
                      fontSize: '1em',
                      background: '#8d4715',
                      color: '#ffffff',
                      padding: '4px 15px',
                      borderRadius: '20px',
                      fontWeight: 'bold',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '8px',
                      boxShadow: '0 2px 5px rgba(0,0,0,0.2)'
                    }}>
                      <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 16 16" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M8 3.5a.5.5 0 0 0-1 0V9a.5.5 0 0 0 .252.434l3.5 2a.5.5 0 0 0 .496-.868L8 8.71V3.5z"></path><path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm7-8A7 7 0 1 1 1 8a7 7 0 0 1 14 0z"></path></svg>
                      {isSolved ? formatTime(solvedTime) : formatTime(elapsedTime)}
                    </div>
                  </div>
                }
              />
            </div>
            <div className="masala-korinish">
              {error ? (
                <div className="xatolik-oynasi">
                  <pre>{error}</pre>
                </div>
              ) : (
                <iframe
                  className="natija"
                  srcDoc={baza}
                  title="output"
                  sandbox="allow-scripts"
                  frameBorder="0"
                  width="100%"
                  height="100%"
                />
              )}
            </div>
          </div>
        </>
      ) : (
        <div style={{ textAlign: "center", padding: "20px" }}>
          <h3>Ushbu bo'limda keyingi masala topilmadi yoki barcha masalalar yechilgan.</h3>
        </div>
      )}

      {/* Sidebar Toggle Shortcut */}
      <button
        type="button"
        className={`sidebar-toggle-btn ${userPanelOpen ? 'side-open' : ''}`}
        onClick={(e) => {
          if (e) e.preventDefault();
          toggleUserPanel();
        }}
        title={userPanelOpen ? "Profilni yopish" : "Profilni ko'rish"}
      >
        {userPanelOpen ? <FaChevronRight /> : <FaChevronLeft />}
      </button>

      {/* Video Yordam Modal (Simplified) */}
      {helpModalOpen && (
        <div className="masala-video-modal-overlay" onClick={() => { setHelpModalOpen(false); }}>
          <div className="masala-video-modal-content" onClick={e => e.stopPropagation()} style={{ width: '95%', maxWidth: '800px', padding: '0' }}>
            <button
              type="button"
              className="modal-close-btn"
              onClick={(e) => {
                if (e) e.preventDefault();
                setHelpModalOpen(false);
              }}
              style={{ top: '15px', right: '15px', zIndex: 10 }}
            >
              <FaTimes />
            </button>

            <div className="help-modal-header" style={{ padding: '20px' }}>
              <h3 style={{ margin: 0, border: 'none', padding: 0 }}>Video Yordam</h3>
              <div className="help-modal-masala-matn" style={{ marginTop: '15px', fontSize: '1.1rem', maxHeight: '100px', overflowY: 'auto' }}>
                {joriyMasala?.text || joriyMasala?.matn}
              </div>
            </div>

            <div className="masala-video-pleyer-quti" style={{ background: '#000', aspectRatio: '16/9', position: 'relative' }}>
              {helpVideos.length === 0 ? (
                <div className="help-video-locked-overlay" style={{ color: 'white', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100%', minHeight: '400px', background: '#1a1a1a' }}>
                  <FaLock style={{ fontSize: '3rem', marginBottom: '20px', color: '#e67e22' }} />
                  <p style={{ fontSize: '1.2rem', marginBottom: '20px' }}>Ushbu video yopiq</p>
                  <button
                    type="button"
                    onClick={(e) => {
                      if (e) e.preventDefault();
                      toast.info("Tez orada qo'shiladi!");
                    }}
                    style={{
                      background: '#e67e22', color: 'white', border: 'none', padding: '10px 30px',
                      borderRadius: '30px', fontWeight: 'bold', cursor: 'pointer', transition: '0.3s'
                    }}
                  >
                    Sotib olish ({joriyMasala?.ball || 0} tanga)
                  </button>
                </div>
              ) : (helpVideos.find(v => v.id === (activeHelpId || (helpVideos[0] ? helpVideos[0].id : null)))?.is_unlocked) ? (
                <>
                  {videoLoading ? (
                    <div className="video-loader-overlay">
                      <div className="video-spinner"></div>
                      <p>Video yuklanmoqda...</p>
                    </div>
                  ) : (
                    <DarsVideoPlayer
                      src={secureVideoUrl || ''}
                      phoneNumber={(localStorage.getItem('loyiha_user_name') || '')}
                    />
                  )}

                  {helpVideos.length > 1 && (
                    <div className="mini-video-switcher" style={{ position: 'absolute', bottom: '10px', right: '10px', display: 'flex', gap: '5px' }}>
                      {helpVideos.map((v, i) => (
                        <div key={v.id}
                          onClick={(e) => {
                            if (e) {
                              e.preventDefault();
                              e.stopPropagation();
                            }
                            setActiveHelpId(v.id);
                          }}
                          style={{
                            width: '35px', height: '35px', borderRadius: '10px',
                            background: (activeHelpId === v.id || (!activeHelpId && i === 0)) ? '#e67e22' : 'rgba(255,255,255,0.2)',
                            display: 'flex', alignItems: 'center', justifyContent: 'center',
                            cursor: 'pointer', color: 'white', fontSize: '14px',
                            transition: '0.3s', border: (activeHelpId === v.id || (!activeHelpId && i === 0)) ? '2px solid white' : '1px solid rgba(255,255,255,0.1)'
                          }}
                          title={v.nomi}
                        >
                          {v.is_unlocked ? (i + 1) : <FaLock style={{ color: '#fff', fontSize: '10px' }} />}
                        </div>
                      ))}
                    </div>
                  )}
                </>
              ) : (
                <div className="help-video-locked-overlay" style={{ color: 'white', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100%', minHeight: '400px', background: '#1a1a1a' }}>
                  <FaLock style={{ fontSize: '3rem', marginBottom: '20px', color: '#e67e22' }} />
                  <p style={{ fontSize: '1.2rem', marginBottom: '20px' }}>Ushbu video yopiq</p>
                  <button
                    type="button"
                    onClick={(e) => {
                      if (e) e.preventDefault();
                      buyHelp(activeHelpId || helpVideos[0]?.id, helpVideos.find(v => v.id === (activeHelpId || helpVideos[0]?.id))?.narx || joriyMasala?.ball);
                    }}
                    style={{
                      background: '#e67e22', color: 'white', border: 'none', padding: '10px 30px',
                      borderRadius: '30px', fontWeight: 'bold', cursor: 'pointer', transition: '0.3s'
                    }}
                  >
                    Sotib olish ({(helpVideos.find(v => v.id === (activeHelpId || helpVideos[0]?.id))?.narx || joriyMasala?.ball)} tanga)
                  </button>
                  {helpVideos.length > 1 && (
                    <div className="mini-video-switcher" style={{ position: 'absolute', bottom: '10px', right: '10px', display: 'flex', gap: '5px' }}>
                      {helpVideos.map((v, i) => (
                        <div key={v.id}
                          onClick={(e) => {
                            if (e) {
                              e.preventDefault();
                              e.stopPropagation();
                            }
                            setActiveHelpId(v.id);
                          }}
                          style={{
                            width: '35px', height: '35px', borderRadius: '10px',
                            background: (activeHelpId === v.id || (!activeHelpId && i === 0)) ? '#e67e22' : 'rgba(255,255,255,0.2)',
                            display: 'flex', alignItems: 'center', justifyContent: 'center',
                            cursor: 'pointer', color: 'white', fontSize: '14px',
                            transition: '0.3s', border: (activeHelpId === v.id || (!activeHelpId && i === 0)) ? '2px solid white' : '1px solid rgba(255,255,255,0.1)'
                          }}
                          title={v.nomi}
                        >
                          {v.is_unlocked ? (i + 1) : <FaLock style={{ color: '#fff', fontSize: '10px' }} />}
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      {/* Custom Confirmation Prompt */}
      {purchaseConfirm && (
        <div className="custom-confirm-overlay" style={{
          position: 'fixed', top: 0, left: 0, width: '100%', height: '100%',
          background: 'rgba(0,0,0,0.5)', zIndex: 3000, display: 'flex',
          alignItems: 'center', justifyContent: 'center', backdropFilter: 'blur(5px)'
        }}>
          <div className="custom-confirm-card" style={{
            background: 'white', padding: '30px', borderRadius: '20px',
            width: '350px', boxShadow: '0 20px 40px rgba(0,0,0,0.2)',
            textAlign: 'center', animation: 'slideUp 0.3s ease'
          }}>
            <div style={{ fontSize: '3rem', color: '#e67e22', marginBottom: '15px' }}>
              <FaPlayCircle />
            </div>
            <h4 style={{ margin: '0 0 10px 0', fontSize: '1.6rem' }}>Video yordam</h4>
            <p style={{ color: '#666', marginBottom: '25px', lineHeight: '1.5', fontSize: '1.1rem' }}>
              Siz <strong>{purchaseConfirm.narx} tangaga</strong> video yordam olmoqchimisiz?
            </p>
            <div style={{ display: 'flex', gap: '10px' }}>
              <button
                type="button"
                onClick={() => {
                  setPurchaseConfirm(null);
                }}
                style={{
                  flex: 1, padding: '12px', borderRadius: '12px', border: '1px solid #ddd',
                  background: 'white', color: '#333', fontWeight: 'bold', cursor: 'pointer'
                }}
              >
                Yo'q
              </button>
              <button
                type="button"
                onClick={() => {
                  processPurchase();
                }}
                style={{
                  flex: 1, padding: '12px', borderRadius: '12px', border: 'none',
                  background: '#e67e22', color: 'white', fontWeight: 'bold', cursor: 'pointer'
                }}
              >
                Ha
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Legacy Video Modal (if needed, keeping purely for backward compatibility if any data still uses joriyMasala.video) */}
      {videoOpen && (
        <div className="masala-video-modal-overlay" onClick={() => setVideoOpen(false)}>
          <div className="masala-video-modal-content" onClick={e => e.stopPropagation()}>
            <button
              type="button"
              className="modal-close-btn"
              onClick={() => {
                setVideoOpen(false);
              }}
            >
              <FaTimes />
            </button>
            <h3>{(joriyMasala?.text || joriyMasala?.matn || "").substring(0, 50)}... - Video Yordam</h3>
            <div className="masala-video-pleyer-quti">
              <DarsVideoPlayer
                src={joriyMasala?.video}
                poster={rasm}
                phoneNumber={userData ? userData.tel : ''}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
}


export default Masala;

